import Footer from './Footer'
import FooterMobile from './FooterMobile'

export {
  Footer,
  FooterMobile
}


// WEBPACK FOOTER //
// ./src/layouts/footer/index.js